import script from "./Audience.vue?vue&type=script&setup=true&lang=js"
export * from "./Audience.vue?vue&type=script&setup=true&lang=js"

import "./Audience.vue?vue&type=style&index=0&id=0958b93a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0958b93a"]])

export default __exports__